var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"estimate-service-list"},[_c('ul',_vm._l((_vm.estimate.estimate_services),function(service){return _c('li',{key:service.service_data.id},[_vm._v(_vm._s(service.service_data.service_code || '')+" "+_vm._s(service.service_data.name || 'No hay trabajos sugeridos')+" (x"+_vm._s(service.service_quantity || '')+")")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }